import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../core/shared/widget/widget-data-param";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ConfirmationService} from "primeng/api";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";

@Component({
    selector: 'mvs-eu-registration-object',
    templateUrl: './eu-registration-object.component.html',
    standalone: false
})
export class EuRegistrationObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    widgetRegistration: WidgetData;

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    override ngOnInit() {
        super.ngOnInit();
    }

    /**
     * On Object Change.
     */
    onObjectChanged() {
        if (this.uiMode !== 'inline') {
            this.widgetRegistration = WidgetFactory.createWidgetTransient(
                'eu.registration.object.data',
                'Registrierung',
                'data',
                'transient',
                'transient',
                'eu.EuRegistration',
                this.dto,
                WidgetDataParam.create("size", "S"),
                WidgetDataParam.create("objectId", this.objectIdentifier.objectId)
            );
        }
    }

}
